import TagManager from 'react-gtm-module';

export function pushGtmEventRegistrationStart(registrationType: 'password' | 'telegram') {
  TagManager.dataLayer({
    dataLayer: {
      event: 'workflowStep',
      workflowName: 'registration',
      workflowStepNumber: 1,
      workflowStepName: 'start',
      workflowCompleteFlag: 0,
      registrationType,
    },
  });
}

export function pushGtmEventFieldChange(fieldName: string) {
  TagManager.dataLayer({
    dataLayer: {
      event: 'workflowStep',
      workflowName: 'registration',
      workflowStepName: 'formfields',
      FieldName: fieldName,
    },
  });
}

export function pushGtmEventRegistrationFailed(errorMessage: string) {
  TagManager.dataLayer({
    dataLayer: {
      event: 'workflowStep',
      workflowName: 'registration',
      workflowStepNumber: 2,
      workflowStepName: 'failed',
      errorMessage,
    },
  });
}

export function pushGtmEventRegistrationComplete(registrationType: 'password' | 'telegram') {
  TagManager.dataLayer({
    dataLayer: {
      event: 'workflowStep',
      workflowName: 'registration',
      workflowStepNumber: 2,
      workflowStepName: 'complete',
      workflowCompleteFlag: 1,
      registrationType,
    },
  });
}

export function pushGtmEventLoginStart(loginType: 'password' | 'telegram') {
  TagManager.dataLayer({
    dataLayer: {
      event: 'workflowStep',
      workflowName: 'login',
      workflowStepNumber: 1,
      workflowStepName: 'start',
      workflowCompleteFlag: 0,
      loginType,
    },
  });
}

export function pushGtmEventLoginComplete(loginType: 'password' | 'telegram') {
  TagManager.dataLayer({
    dataLayer: {
      event: 'workflowStep',
      workflowName: 'login',
      workflowStepNumber: 2,
      workflowStepName: 'complete',
      workflowCompleteFlag: 1,
      loginType,
    },
  });
}

export function pushGtmEventLoginFailed(errorMessage: string) {
  TagManager.dataLayer({
    dataLayer: {
      event: 'workflowStep',
      workflowName: 'login',
      workflowStepNumber: 2,
      workflowStepName: 'failed',
      errorMessage,
    },
  });
}

export function pushGtmEventOfferClick(offerTitle: string, offerType: string) {
  TagManager.dataLayer({
    dataLayer: {
      event: 'workflowStep',
      workflowName: 'purchase tickets',
      workflowStepName: 'offer clicks',
      offerTitle,
      offerType,
    },
  });
}

export function pushGtmEventBuyTickets(offerTitle: string, offerType: string, depositAmountSystem: number) {
  TagManager.dataLayer({
    dataLayer: {
      event: 'workflowStep',
      workflowName: 'purchase tickets',
      workflowStepName: 'checkout',
      offerTitle,
      offerType,
      depositAmountSystem,
    },
  });
}

export function pushGtmEventConfirmPurchase(
  offerTitle: string,
  offerType: string,
  depositAmountSystem: number,
  customerId: string,
  transactionId: string,
) {
  TagManager.dataLayer({
    dataLayer: {
      event: 'workflowStep',
      workflowName: 'purchase tickets',
      workflowStepName: 'deposit',
      offerTitle,
      offerType,
      depositAmountSystem,
      customerId,
      transactionId,
    },
  });
}

export function pushGtmEventPurchaseFailed(
  offerTitle: string,
  offerType: string,
  depositAmountSystem: number,
  customerId: string,
  transactionId: string,
  errorMessage: string,
) {
  TagManager.dataLayer({
    dataLayer: {
      event: 'workflowStep',
      workflowName: 'purchase tickets',
      workflowStepName: 'deposit',
      offerTitle,
      offerType,
      depositAmountSystem,
      customerId,
      transactionId,
      errorMessage,
    },
  });
}
